import { useCallback, useEffect, useState } from 'react';

import { logToSentry, useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type CustomerData } from '../../shared/types';
import { type HeaderContext } from '../types';

interface UseCustomerInformationResult {
    readonly customerInfo: CustomerData | null;
    readonly hasFetched: boolean;
}

let customerPromise: Promise<CustomerData | null> | null = null;

function useCustomerInformation(): UseCustomerInformationResult {
    const [customerInfo, setCustomerInfo] = useState<CustomerData | null>(null);
    const [hasFetched, setHasFetched] = useState(false);
    const { fetchCustomerInformation } = useFragmentContext<HeaderContext>();

    const fetch = useCallback(async (): Promise<void> => {
        if (!customerPromise) {
            customerPromise = fetchCustomerInformation();
        }

        try {
            setCustomerInfo(await customerPromise);
            setHasFetched(true);
        } catch (error) {
            logToSentry(error as Error);
            setCustomerInfo(null);
            setHasFetched(true);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return { customerInfo, hasFetched };
}

export { useCustomerInformation };
